<template>
  <div>
    <div class="flex flex-col p-4 items-center">
      <div class="w-full flex flex-row space-x-4 mb-4 items-center justify-center">
        <div class="w-full md:w-1/2 bg-white rounded-lg shadow p-3 flex flex-col items-center justify-center" id="report-expenses1">
          <h1 class="text-2xl font-semibold mb-2">Desgloce de Gastos</h1>
          <Chart :options="chartOptions" />
        </div>
        <div class="w-full md:w-1/2 bg-white rounded-lg shadow p-3" id="report-expenses2">
          <h1 class="text-lg font-semibold">
            Distribución de Gastos del último mes
          </h1>
          <Chart :options="lastMonthChartOptions" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import numbers from "@/utils/numbers";
import { Chart } from "highcharts-vue";
export default {
  name: "SummaryReports",
  components: {
    Chart,
  },
  props: {
    // Example: Accept a prop to provide data as a decimal list
    monthsExpensesProducts: {
      type: Array,
      default: () => [],
    },
    monthsExpensesStatics: {
      type: Array,
      default: () => [],
    },
    monthsExpensesDynamics: {
      type: Array,
      default: () => [],
    },
    widthChart: {
      type: Number,
      default: 600,
    },
  },
  data() {
    return {
      chartOptions: {
        chart: {
          type: "area",
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null, // Oculta el título del gráfico
        },
        xAxis: {
          categories: this.monthNames(),
          title: {
            text: "Mes",
          },
        },
        yAxis: {
          title: {
            text: "Monto",
          },
        },
        tooltip: {
          shared: true,
          valuePrefix: "$",
        },
        series: [
          {
            name: "Gastos fijos",
            data: this.monthsExpensesStatics,
            color: "#f59e42", // naranja
            fillOpacity: 0.5,
          },
          {
            name: "Gastos variables",
            data: this.monthsExpensesDynamics,
            color: "#3b82f6", // azul
            fillOpacity: 0.5,
          },
          {
            name: "Inversion en inventario",
            data: this.monthsExpensesProducts,
            color: "#22c55e", // verde
            fillOpacity: 0.5,
          },
        ],
      },
      lastMonthChartOptions: {
        chart: {
          type: "pie",
          height: 350,
          width: 450,
          reflow: true,
        },
        title: {
          text: null,
        },
        tooltip: {
          pointFormat:
            "{series.name}: <b>${point.y}</b> ({point.percentage:.1f}%)",
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              format:
                "<b>{point.name}</b>: ${point.y} ({point.percentage:.1f}%)",
            },
          },
        },
        series: [
          {
            name: "Gastos",
            colorByPoint: true,
            data: [
              {
                name: "Gastos fijos",
                y: this.monthsExpensesStatics && this.monthsExpensesStatics.length
                  ? this.monthsExpensesStatics[this.monthsExpensesStatics.length - 1]
                  : 0,
                color: "#f59e42",
              },
              {
                name: "Gastos variables",
                y: this.monthsExpensesDynamics && this.monthsExpensesDynamics.length
                  ? this.monthsExpensesDynamics[this.monthsExpensesDynamics.length - 1]
                  : 0,
                color: "#3b82f6",
              },
              {
                name: "Inversion en inventario",
                y: this.monthsExpensesProducts && this.monthsExpensesProducts.length
                  ? this.monthsExpensesProducts[this.monthsExpensesProducts.length - 1]
                  : 0,
                color: "#22c55e",
              },
            ],
          },
        ],
      },
    };
  },
  computed: {},
  methods: {
    monthNames() {
      const months = [
        "Enero",
        "Febrero",
        "Marzo",
        "Abril",
        "Mayo",
        "Junio",
        "Julio",
        "Agosto",
        "Septiembre",
        "Octubre",
        "Noviembre",
        "Diciembre",
      ];
      return months.slice(0, this.monthsExpensesStatics.length);
    },
    moneyFormat(value) {
      const { currencySymbol } = this.$store.state.account;
      return numbers.moneyFormat(value, currencySymbol);
    },
  },
};
</script>

<style scoped>
.reports-index {
  margin-top: 40px;
}
</style>
